<template>
  <form :class="$style.search" data-id="search-wrap" novalidate @submit.prevent="onSubmit">
    <Input
      id="search"
      :class="$style.input"
      :placeholder="$t('search')"
      autocomplete="off"
      :model.sync="query"
    >
      <span v-if="query" :class="$style.clearButton" @click="clearInput"></span>
    </Input>
  </form>
</template>

<script>
import { ROUTE_NAMES, SEARCH_URL_PARAM } from '@/constants/route-names'
import Input from '@/components/Form/Input.vue'

export default {
  name: 'Search',
  components: {
    Input,
  },

  i18n: {
    messages: {
      en: { search: 'Search' },
      fr: { search: 'Recherche' },
    },
  },

  data() {
    return {
      query: this.$route.query[SEARCH_URL_PARAM] || '',
    }
  },

  watch: {
    $route() {
      this.query = this.$route.query[SEARCH_URL_PARAM] || ''
    },

    query: {
      immediate: true,
      handler() {
        if (
          this.isAdminReportListRoute() &&
          this.query.length !== 1 &&
          this.query !== this.$route.query[SEARCH_URL_PARAM]
        ) {
          const fn = this.$route.query[SEARCH_URL_PARAM] ? 'replace' : 'push'

          this.$router[fn](
            this.localeRoute({
              name: ROUTE_NAMES.admin.reports,
              params: { ...this.$route.params },
              query: {
                ...this.$route.query,
                [SEARCH_URL_PARAM]: this.query || undefined,
              },
            })
          )
        }
      },
    },
  },

  methods: {
    clearInput() {
      this.query = ''
    },

    isAdminReportListRoute() {
      return this.$route.name?.startsWith(ROUTE_NAMES.admin.reports)
    },

    onSubmit() {
      if (!this.isAdminReportListRoute()) {
        this.$router.push(
          this.localeRoute({
            name: ROUTE_NAMES.admin.reports,
            query: { [SEARCH_URL_PARAM]: this.query },
          })
        )
      }
    },
  },
}
</script>

<style lang="scss" module>
.search {
  flex: 1;
  margin: auto 0;
}

// more specificity to overwrite styles from FieldWrapper.vue
.search[data-id='search-wrap'] {
  .input {
    margin-top: 0;
    max-width: 600px;
    padding-left: 20px;

    :global {
      .input__field {
        padding-right: 48px;
      }
    }
  }
}

.clearButton {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  background-color: transparentize($color-white, 0.2);
  box-shadow: 0px 0px 5px transparentize($color-black, 0.7);
  transition:
    background 0.1s ease-in-out,
    box-shadow 0.1s ease-in-out;
  z-index: 50;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 1px;
    background-color: $color-grey-2-5;
    transition: background-color 0.2s ease-in-out;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  &:hover {
    box-shadow: 0px 0px 2px transparentize($color-black, 0.4);
  }

  &:hover::before,
  &:hover::after {
    background-color: $color-black;
  }
}
</style>
